/**
 * Configuración del campo asignado (agente/asesor) según la fuente de interés.
 * Responsabilidad única: decidir si se muestra el campo y con qué datos (SRP).
 * Para nuevas fuentes solo se añaden entradas aquí, sin tocar el componente (OCP).
 */
import {
  ASESOR_CHIPLO_FIELD_ID,
  FUENTES_INTERES_CLIENTE_OPTIONS,
  NOMBRE_INMOBILIARIA_FIELD_ID,
} from '../../../../../constants';

export const SOURCES_WITHOUT_ASSIGNEE_FIELD = [
  FUENTES_INTERES_CLIENTE_OPTIONS.INSTAGRAM,
  FUENTES_INTERES_CLIENTE_OPTIONS.FACEBOOK,
  FUENTES_INTERES_CLIENTE_OPTIONS.LINKEDIN,
];

const uppName = (name) => name.toUpperCase();

export const normalizeAssigneeItem = (item) => ({
  _id: item._id,
  name: uppName(item.name ?? item.fullName ?? ''),
  phone: item.phone ?? '',
});

const DEFAULT_SOURCE = FUENTES_INTERES_CLIENTE_OPTIONS.INMOBILIARIA_DESARROLLADOR;

const BUILD_CONFIGS = {
  [FUENTES_INTERES_CLIENTE_OPTIONS.ASESOR_CHIPLO]: (deps) => ({
    source: FUENTES_INTERES_CLIENTE_OPTIONS.ASESOR_CHIPLO,
    fieldId: ASESOR_CHIPLO_FIELD_ID,
    label: 'Asesor',
    sectionTitle: 'Asesor Inmobiliario',
    fetchList: (entityId) => deps
      .entityAPI.getAsesoresByCompanyAndEntityId(deps.companyId, entityId),
    getById: (id) => deps.entityAPI.getAsesorDataById(deps.companyId, id),
  }),
  [FUENTES_INTERES_CLIENTE_OPTIONS.INMOBILIARIA_DESARROLLADOR]: (deps) => ({
    source: FUENTES_INTERES_CLIENTE_OPTIONS.INMOBILIARIA_DESARROLLADOR,
    fieldId: NOMBRE_INMOBILIARIA_FIELD_ID,
    label: 'Inmobiliaria',
    sectionTitle: 'Inmobiliaria',
    fetchList: () => deps
      .entityAPI.getEntitiesLandingData(deps.companyId),
  }),
};

/**
 * Devuelve la config del campo asignado para la fuente de interés, o null si no debe mostrarse.
 * @param {string} interestSource - Valor del campo "Fuente de interés"
 * @param {{ companyId: string, entityAPI: object }} deps - Dependencias (inyección para tests/OCP)
 * @returns {null | { fieldId: string, label: string, sectionTitle: string,
 *   fetchList: Function, getById: Function }}
 */
export function getAssigneeConfig(interestSource, deps) {
  if (SOURCES_WITHOUT_ASSIGNEE_FIELD.includes(interestSource)) {
    return null;
  }
  const build = BUILD_CONFIGS[interestSource] ?? BUILD_CONFIGS[DEFAULT_SOURCE];
  return build ? build(deps) : null;
}
